import React from 'react';
import type { ClinicalAmendment } from '../../../services/clinicalAmendmentService';
import ConsultationStatusBadge from './ConsultationStatusBadge';

interface AmendmentListProps {
  amendments: ClinicalAmendment[];
  renderActions?: (amendment: ClinicalAmendment) => React.ReactNode;
}

/**
 * Amendments shown alongside the unchanged original (clinical-record-amendments
 * R2), each with its own draft/signed badge. Shared by the detail page
 * (read-only) and AmendmentDrawer (with per-draft actions).
 */
const AmendmentList: React.FC<AmendmentListProps> = ({ amendments, renderActions }) => (
  <ul className="list-unstyled mb-0">
    {amendments.map((a) => (
      <li key={a.id} className="border rounded p-2 mb-2">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <strong className="small">{a.reason}</strong>
          <ConsultationStatusBadge status={a.status} signatureMethod={a.signature_method} />
        </div>
        <p className="mb-1 small" style={{ whiteSpace: 'pre-wrap' }}>{a.amendment_text}</p>
        {renderActions?.(a)}
      </li>
    ))}
  </ul>
);

export default AmendmentList;
